if (!customElements.get('darchi-pairings')) {
  customElements.define('darchi-pairings', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded || !this.dataset.url) return;
      if (this.hidden || !('IntersectionObserver' in window)) {
        this.loadPairings();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.observer.disconnect();
          this.loadPairings();
        }
      }, { rootMargin: '200px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    async loadPairings() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      this.controller = new AbortController();
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal });
        if (!response.ok) return;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const pairings = [...document.querySelectorAll('darchi-pairings')].find(
          (element) => element.dataset.productId === this.dataset.productId &&
            element.dataset.source === 'complementary' && Number(element.dataset.count) > 0
        );
        if (!pairings || !this.isConnected) return;
        this.innerHTML = pairings.innerHTML;
        this.dataset.source = pairings.dataset.source;
        this.dataset.count = pairings.dataset.count;
        this.hidden = false;
      } catch (error) {
        // Keep the server-rendered provisional pairings if recommendations are unavailable.
      }
    }
  });
}

